import React from 'react';
import Icon from './Icon';
import { WandSparkles } from 'lucide-react';
import { Button } from '../index';

export interface UpgradeCtaCardProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onUpgrade?: () => void;
  className?: string;
  disabled?: boolean;
}

/**
 * UpgradeCtaCard
 *
 * A reusable, customizable card for upgrade CTAs.
 * Used in project lists, chat, upload, etc.
 */

export const UpgradeCtaCard: React.FC<UpgradeCtaCardProps> = ({
  title = 'Upgrade to unlock more',
  description = 'Unlock unlimited projects and advanced features.',
  buttonText = 'Upgrade',
  onUpgrade,
  className = '',
  disabled = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (typeof onUpgrade === 'function') {
      e.preventDefault();
      onUpgrade();
    }
    // If string, let <a> handle navigation
  };
  return (
    <div
      className={`flex flex-col items-center justify-center border-2 border-dashed border-[#3E4784] rounded-3xl p-6 bg-white min-h-[180px] ${className}`}
      data-testid="upgrade-cta-card"
    >
      <div className="flex flex-col items-center gap-1 w-11/12">
        <div className="bg-[#4B579F] w-7 h-7 rounded-sm p-2 mb-2">
          <Icon icon={WandSparkles} size={12} stroke='#fff' />
        </div>
        <div className="font-semibold text-[#252B37] text-center text-sm">{title}</div>
        <div className="text-xs text-[#414651] text-center mb-3">{description}</div>
        <Button
          variant="secondary-gray"
          onClick={onUpgrade}
          disabled={disabled}
          size="sm"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

UpgradeCtaCard.displayName = 'UpgradeCtaCard';

export default UpgradeCtaCard;
